var React = require('react');

function HDots (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.001 7.8a2.2 2.2 0 1 0 0 4.402A2.2 2.2 0 0 0 10 7.8zm-7 0a2.2 2.2 0 1 0 0 4.402A2.2 2.2 0 0 0 3 7.8zm14 0a2.2 2.2 0 1 0 0 4.402A2.2 2.2 0 0 0 17 7.8z"}));
}

HDots.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = HDots;

HDots.default = HDots;
